// extracted by mini-css-extract-plugin
export var brand = "_1r-8";
export var compact = "_1r-5";
export var extraSmall = "_1r-6";
export var icon = "_1r-0";
export var large = "_1r-3";
export var light = "_1r-1";
export var medium = "_1r-4";
export var outline = "_1r-a";
export var primaryDark = "_1r-9";
export var primaryLight = "_1r-7";
export var primaryModern = "_1r-b";
export var success = "_1r-2";